(() => {
  const installation = document.currentScript;
  const pixelId = installation?.dataset.pixelId;
  if (!pixelId || installation.dataset.initialized === 'true') return;
  installation.dataset.initialized = 'true';
  installation.dataset.status = 'waiting-for-privacy';
  let initialized = false;
  let pageViewed = false;

  function initializePixel() {
    // Load the official SDK only after Shopify permits measurement.
    if (!window.oaiq) {
      const queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
      const sdk = document.createElement('script');
      sdk.async = true;
      sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      installation.dataset.sdkState = 'loading';
      sdk.addEventListener('load', () => { installation.dataset.sdkState = 'loaded'; });
      sdk.addEventListener('error', () => {
        installation.dataset.sdkState = 'failed';
        installation.dataset.status = 'sdk-error';
      });
      document.head.appendChild(sdk);
    }
    window.oaiq('consent', false);
    window.oaiq('init', {pixelId, debug: installation.dataset.debug === 'true'});
    initialized = true;
  }

  function updateConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    try {
      const allowed = privacy.analyticsProcessingAllowed()
        && privacy.marketingAllowed()
        && privacy.saleOfDataAllowed();
      installation.dataset.consent = String(Boolean(allowed));
      if (!allowed) {
        if (initialized) window.oaiq('consent', false);
        installation.dataset.status = 'blocked-by-privacy';
        return;
      }
      if (!initialized) initializePixel();
      window.oaiq('consent', true);
      if (!pageViewed) {
        window.oaiq('measure', 'page_viewed', {type: 'contents'});
        pageViewed = true;
      }
      installation.dataset.status = 'enabled';
    } catch {
      if (initialized) window.oaiq('consent', false);
      installation.dataset.status = 'privacy-error';
    }
  }

  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy) { updateConsent(); return; }
    if (!window.Shopify?.loadFeatures) {
      installation.dataset.status = 'privacy-unavailable';
      return;
    }
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
      if (error) { installation.dataset.status = 'privacy-error'; return; }
      updateConsent();
    });
  }

  document.addEventListener('visitorConsentCollected', updateConsent);
  loadPrivacy();
  if (installation.dataset.status === 'privacy-unavailable') {
    window.addEventListener('load', loadPrivacy, {once: true});
  }
})();
